import { googleLogout } from "@react-oauth/google";
import { Dropdown, message } from "antd";
import React from "react";
import { useCookies } from "react-cookie";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../component/image/logo.png";
import { MenuOutlined, UserOutlined } from "@ant-design/icons";

export default function Header({ onMenuClick }) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const location = useLocation();

  const logout = () => {
    googleLogout();
    removeCookie("user");
    message.success("Đăng xuất thành công!");
    navigate("/login");
  };

  const items = [
    {
      key: '1',
      label: <a href={`/profile/${cookies?.user?.id}`}>Profile</a>,
    },
    {
      key: '2',
      label: <a onClick={() => logout()}>Logout</a>,
    },
  ];

  const navLinks = [
    { label: "Topic", to: "/topic" },
    { label: "Blog", to: "/blog" },
    { label: "Playlist", to: "/playlist" },
  ];

  const isActive = (path) => location?.pathname.includes(path);

  return (
    <nav className="sticky top-0 z-40 bg-white shadow-md border-b border-gray-100">
      <div className="max-w-screen-xl flex items-center justify-between mx-auto px-4 py-2">
        {/* Left: Menu button (mobile) + Logo */}
        <div className="flex items-center gap-3">
          {/* Hamburger - mobile only */}
          <button
            onClick={onMenuClick}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <MenuOutlined className="text-lg" />
          </button>

          <a href="/" className="flex items-center gap-2">
            <img src={logo} className="w-9 h-9 rounded-full" alt="Logo" />
            <p className="text-gray-900 font-bold text-lg hidden sm:block">VuaLingo</p>
          </a>
        </div>

        {/* Center: Nav links (desktop only) */}
        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive(link.to)
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Dropdown
            dropdownRender={() => (
              <div className="bg-white rounded-xl p-3 shadow-xl border border-gray-100 min-w-[140px]">
                <Link className="block px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-50 font-medium text-sm" to="/ranking/streak">
                  🔥 BXH Streak
                </Link>
                <Link className="block px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-50 font-medium text-sm" to="/ranking/timer">
                  ⏱️ BXH Timer
                </Link>
              </div>
            )}
            placement="bottom"
            trigger={['click']}
          >
            <span className={`px-4 py-2 rounded-lg text-sm font-medium cursor-pointer transition-colors ${
              isActive("/ranking")
                ? "bg-blue-50 text-blue-600"
                : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            }`}>
              Ranking
            </span>
          </Dropdown>
        </div>

        {/* Right: User section */}
        <div className="flex items-center gap-3">
          {cookies?.user ? (
            <Dropdown menu={{ items }} placement="bottomRight">
              <div className="cursor-pointer">
                {cookies?.user?.avatar ? (
                  <img src={cookies.user.avatar} className="h-9 w-9 rounded-full object-cover ring-2 ring-blue-100" crossOrigin="anonymous" alt="Avatar" />
                ) : (
                  <div className="h-9 w-9 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow">
                    <UserOutlined className="text-white text-sm" />
                  </div>
                )}
              </div>
            </Dropdown>
          ) : (
            <Link
              to="/login"
              className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-5 py-2 rounded-lg text-sm font-semibold hover:from-blue-600 hover:to-blue-700 transition-all shadow-md shadow-blue-500/20"
            >
              Đăng nhập
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
